var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-cell-string',_vm._b({},'iv-cell-string',{ ..._vm.$attrs, ..._vm.$props, value: _vm.generatedReversedOptions[_vm.value] },false))
}
var staticRenderFns = []

export { render, staticRenderFns }